// Attach the signed-in user's Supabase token to every RAG-backend axios call.
//
// The RAG service (rag-testing) now fail-closes its provider routes
// (/askanything, /add_embedding, knowledgebase ops, ...) behind an ordinary
// user JWT — see tikcare_rag src/credit_wallet_rag_boundary.py. The ~18 call
// sites all use bare axios, so one request interceptor keyed on the base URL
// covers them (and any future ones) instead of editing each call. Backward
// compatible: a backend that does not check the header simply ignores it.
import axios from 'axios';
import { supabase } from '../supabaseClient.js';

const RAG_BASE = process.env.REACT_APP_RAG_BACKEND_URL;

axios.interceptors.request.use(async (config) => {
  if (RAG_BASE && typeof config.url === 'string' && config.url.startsWith(RAG_BASE)) {
    try {
      const { data: { session } = {} } = await supabase.auth.getSession();
      if (session?.access_token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${session.access_token}`;
      }
    } catch (error) {
      // A token lookup failure must not block the request itself; the backend
      // will answer 401 and the call site's own error handling takes over.
      console.error('RAG auth header attach failed:', error);
    }
  }
  return config;
});
